import {generalRequest} from "@/lib/services/requests";
import {myAcademy} from "@/lib/services/academyService";
import {useMutation, useQuery} from "@tanstack/react-query";

export function useApiCreateStudentUserAcademyRegister() {
    return useMutation({
        mutationFn: (data) =>
            ((async (data = {}) => {
                return generalRequest.post(`/student/academy/register`, data)
            })(data))
    });
}


export function useApiUpdateStudentProfile() {
    return useMutation({
        mutationFn: (data) =>
            ((async (data = {}) => {
                return generalRequest.patch(`/student/profile`, data)
            })(data))
    });
}


export const useApiReadStudentProfile = () => {
    return useQuery({
        queryKey: ['student', 'user_academy'],
        queryFn: () => ((async () => {
            return generalRequest.get(`/student/profile`)
        })()),
    })
}


export const useApiSearchAdminMembers = (args) => {

    return useQuery({
        queryKey: ['admin', 'members', 'list', args, myAcademy()],
        queryFn: () => ((async (args) => {
            return generalRequest.get(`/admin/members`, {params: args})
        })(args)),
    })
}


export const useApiGetAdminMember = (id) => {

    return useQuery({
        queryKey: ['admin', 'members', 'get', id, myAcademy()],
        queryFn: () => ((async (id) => {
            return generalRequest.get(`/admin/members/${id}`)
        })(id)),
    })
}


export function useApiUpdateAdminProfile() {
    return useMutation({
        mutationFn: (data) =>
            ((async (data) => {
                return generalRequest.put(`/admin/members/${data?.id}`, data)
            })(data))
    });
}


export function useApiAdminLoginByUser() {
    return useMutation({
        mutationFn: (userId) =>
            ((async (userId) => {
                return generalRequest.post(`/admin/login/${userId?.user_id}`)
            })(userId))
    });
}


export function useApiUpdateTeacherProfile() {
    return useMutation({
        mutationFn: (data) =>
            ((async (data = {}) => {
                return generalRequest.patch(`/teacher/profile`, data)
            })(data))
    });
}


export const useApiReadTeacherProfile = () => {
    return useQuery({
        queryKey: ['teacher', 'user_academy'],
        queryFn: () => ((async () => {
            return generalRequest.get(`/teacher/profile`)
        })()),
    })
}


export const useApiSearchTeacherStudentsDetail = (args) => {
    return useQuery({
        queryKey: ['teacher', 'students', 'search', 'detail', args?.student_id, args?.lesson_id],
        queryFn: () => ((async (args) => {
            return generalRequest.get(`/teacher/lessons/${args?.lesson_id}/students/${args?.student_id}`)
        })(args)),
    })
}


export const useApiSearchTeacherStudents = (args) => {
    return useQuery({
        queryKey: ['teacher', 'students', 'search', 'list', args],
        queryFn: () => ((async (args) => {
            return generalRequest.get(`/teacher/students`, {params: args})
        })(args)),
    })
}

